export default __webpack_public_path__ + "static/media/Codigo_de_Gobierno_Corporativo_Swiss_Medical_SA.aef7951e.pdf";